/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S2_CompanyInputs */

const tr_kvkkbasvuru_s2_company = /** @type {(inputs: Kvkkbasvuru_S2_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse® E-Ticaret Limited Şirketi`)
};

const en_kvkkbasvuru_s2_company = /** @type {(inputs: Kvkkbasvuru_S2_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse® E-Ticaret Limited Şirketi`)
};

const de_kvkkbasvuru_s2_company = /** @type {(inputs: Kvkkbasvuru_S2_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse® E-Ticaret Limited Şirketi`)
};

const ru_kvkkbasvuru_s2_company = /** @type {(inputs: Kvkkbasvuru_S2_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emonse® E-Ticaret Limited Şirketi`)
};

/**
* | output |
* | --- |
* | "Emonse® E-Ticaret Limited Şirketi" |
*
* @param {Kvkkbasvuru_S2_CompanyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s2_company = /** @type {((inputs?: Kvkkbasvuru_S2_CompanyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S2_CompanyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s2_company(inputs)
	if (locale === "de") return de_kvkkbasvuru_s2_company(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s2_company(inputs)
	return tr_kvkkbasvuru_s2_company(inputs)
});